import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'membership-upsell',
		path: '/membership/upsell',
		component: loadable(async () => import(/* webpackChunkName: "pages/membership_upsell" */ './index'), {
			exportName: 'MembershipUpsell',
			fallback: Loading,
		}),
		frame: {
			header: true,
			footer: true,
		},
	},
];
